import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Ejecutivo from './Ejecutivo'
import ACCESS from '../../../ACCESS.js';

class Ejecutivos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'ejecutivo/filter', deleteUrl: 'ejecutivo/delete', deleteField: 'ejecutivo_nombre', modUrl: '/Catalogo/Ejecutivo' },
      TableOp.Table('Ejecutivos', [
        { label: 'Clave', id: 'ejecutivo' },
        { label: 'Nombre', id: 'ejecutivo_nombre' },
        { label: 'Sucursal', id: 'sucursal_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_EJECUTIVOS.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_EJECUTIVOS.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <Ejecutivo  onSave={() => {this.table()}}></Ejecutivo>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(Ejecutivos)